import { render } from "./label-tool.vue?vue&type=template&id=d92da5ae"
import script from "./label-tool.vue?vue&type=script&lang=js"
export * from "./label-tool.vue?vue&type=script&lang=js"

import exportComponent from "/var/lib/jenkins/workspace/div2-univRenewal-trunk-production/web/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__